import { Box } from "@mui/material"
import { LineChart } from "@mui/x-charts"
import { useEffect, useMemo, useRef } from "react"

const DashboardWidgetTrendlineChart = ({
  widgetConfig,
  trendContent,
  setItemToRetrieveRows,
  // Indicates if we're showing trend data, and showing job totals
  // in which case we need to show a warning that the trend data
  // may not match the live data
  isTrendTotalCount,
}) => {
  const dimensions = useMemo(() => {
    const showLegend = trendContent.series.length <= 10

    const legendTypeSpace = {
      category: 15,
      location: 15,
      centre_id: 15,
      supplier_id: 30,
      priority: 10,
      status: 15,
    }

    const legendSpace = legendTypeSpace[widgetConfig.config.group_by] || 10

    const legendHeight = showLegend
      ? 35 + trendContent.series.length * legendSpace
      : 0

    const result = {
      height: showLegend ? 300 + legendHeight : 300,
      showLegend: showLegend,
      marginBottom: showLegend ? legendHeight : 50,
    }
    return result
  }, [widgetConfig, trendContent])

  return (
    <Box>
      <LineChart
        xAxis={trendContent.xAxis}
        yAxis={[
          {
            tickMinStep: 1,
            min: 0,
          },
        ]}
        series={trendContent.series}
        width={widgetConfig.config.expanded ? 280 : 100}
        margin={{
          top: 30,
          bottom: dimensions.marginBottom,
          left: 35,
          right: 20,
        }}
        tooltip={{ trigger: "axis" }}
        colors={[
          "#708090",
          "#708238",
          "#5F9EA0",
          "#483C32",
          "#605856",
          "#5F8A8B",
          "#A9A9A9",
          "#9EA79D",
          "#36454F",
          "#C19A6B",
          "#367588",
          "#3E6257",
          "#658E67",
          "#8A3324",
        ]}
        height={dimensions.height}
        slotProps={{
          legend: {
            direction: "row",
            position: { vertical: "bottom", horizontal: "middle" },
            padding: 0,
            hidden: !dimensions.showLegend,
          },
        }}
        onMarkClick={(event, d) => {
          // Find the trend data item with the same seriesId as the mark

          // get last number after last dash in the seriesId property of d as an integer, e.g. if auto-generated-id-0, we want the 0
          const seriesIndex = parseInt(d.seriesId.split("-").pop())

          const seriesName = trendContent.series[seriesIndex].label

          const clickedItem = trendContent.series[seriesIndex]

          if (clickedItem) {
            const item = {
              count: undefined,
              value: seriesName,
              sql: clickedItem.sql,
            }

            if (isTrendTotalCount) {
              // Provided to indicate that snapshot totals may not match live data retrieved
              // i.e. since trend data snapshotted every Sunday, but live data is current
              item.showTrendDataInfo = true
            }

            setItemToRetrieveRows(item)
          }
        }}
        onLineClick={(event, d) => {}}
      />
    </Box>
  )
}

export default DashboardWidgetTrendlineChart
